import { Capacitor } from "@capacitor/core";
import AppContext from "components/AppContext";
import { last, pull } from "lodash";
import { useContext, useEffect } from "react";
const ROOT_APP_PAGES = ["/app/launch", "/create", "/auth/sign-in", "/account"];

export const BackButtonStack = () => {
  const listeners = [];

  const handleBack = () => {
    if (listeners.length) {
      last(listeners)();
      return;
    }

    if (!ROOT_APP_PAGES.includes(window.location.pathname)) {
      window.history.back();
      return;
    }

    if (Capacitor.isPluginAvailable("App")) {
      Capacitor.Plugins.App.exitApp();
    }
  };

  const listen = () => {
    if (!process.browser || !Capacitor.isPluginAvailable("App")) {
      return;
    }
    const listener = Capacitor.Plugins.App.addListener(
      "backButton",
      handleBack
    );
    window.addEventListener("unload", function (event) {
      listener.remove();
    });
  };

  const addListener = (callback) => {
    listeners.push(callback);
    return {
      remove: () => {
        pull(listeners, callback);
      },
    };
  };

  listen();

  return {
    addListener,
  };
};

export const useBackButton = (callback) => {
  const { backButtonStack } = useContext(AppContext);
  useEffect(() => {
    const listener = backButtonStack.addListener(callback);
    return listener.remove;
  }, [backButtonStack, callback]);
};

export const BackButtonHandler = ({ onBack }) => {
  useBackButton(onBack);
  return null;
};
